import { useState } from 'react';

import { partition } from 'lodash';
import { Plus } from 'lucide-react';
import { Button, ProgressMulti, Box } from 'twyne-new.ui'

import Form from './Form';
import Item from './Item';

export default function List({ device, data, options, onChange, disabled, label }) {
  const total = data?.reduce((total, form) => total + Number(form.weight), 0)

  const reorder = forms => {
    const [activated, disabled] = partition(forms, form => form.active)
    return [...activated, ...disabled]
  }

  const handleAdd = form => {
    const active = data?.filter(form => form.id) || []
    active.push(form)
    const update = reorder(active)
    onChange(device, update)
  }

  const handleRemove = index => {
    data.splice(index, 1)
    onChange(device, [...data])
  }

  const handleChange = (index, values) => {
    data[index] = values
    const update = reorder(data)
    onChange(device, update)
  }

  return <>
    <div className='flex items-center justify-between'>
      {label}
      <Add options={options} onAdd={handleAdd} disabled={disabled} />
    </div>
    <Box aria-disabled={disabled}>
      <ProgressMulti fadeColor>
        {data?.map((item, index) => <Item
          key={index}
          index={index}
          data={item}
          device={device}
          options={options}
          onChange={handleChange}
          onRemove={handleRemove}
          total={total}
          disabled={disabled} />)}
      </ProgressMulti>
    </Box>
  </>
}

function Add({ options, onAdd, disabled }) {
  const [toggle, setToggle] = useState(false)

  return <div>
    <Button className='float-right' size='sm' color='accent' onClick={() => setToggle(!toggle)} disabled={disabled}>
      <Plus size={14} />
      Add
    </Button>
    <Form options={options} onAdd={onAdd} toggle={toggle} setToggle={setToggle} />
  </div>
}
